const DAY_IN_MS = 86400000;

export const computeSurroundingDates = date => {
  const selectedDate = new Date(date);
  const prev = new Date(selectedDate.valueOf() - DAY_IN_MS);
  const next = new Date(selectedDate.valueOf() + DAY_IN_MS);

  const prevDate = prev.toISOString().substring(0, 10);
  const nextDate = next.toISOString().substring(0, 10);

  return {
    prevDate,
    nextDate,
  };
};
